(function($) {

	$(".m-code-toggle__tab").bind("click",function(){
		$(this).siblings().removeClass("m-code-toggle__tab--isactive");
		$(this).addClass("m-code-toggle__tab--isactive");
		var codeIndex = $(this).index();
		$(this).parent().parent().find(".m-code__container--isactive").removeClass("m-code__container--isactive");
		$(this).parent().parent().find(".m-code__container:eq(" + codeIndex + ")").addClass("m-code__container--isactive");
	});

})(jQuery);